module.exports = require("./ff-Latn-GN.d.ts");